module.exports = __webpack_public_path__ + "img/ios_black.1ca88165.svg";